/* eslint-disable no-undefined */
export const PII_KEYS: ReadonlySet<string> = new Set<string>([
  "password",
  "currentPassword",
  "newPassword",
  "passwordResetToken",
  "invitationToken",
  "token",
  "refreshToken",
  "accessToken",
  "apiKey",
  "secret",
  "clientSecret",
]);

export const MAX_PAYLOAD_BYTES = 8 * 1024;

function deepRedact(value: unknown): unknown {
  return deepRedactWithCycleGuard(value, new WeakSet());
}

function deepRedactWithCycleGuard(value: unknown, seen: WeakSet<object>): unknown {
  if (value == null) {
    return value;
  }

  if (Array.isArray(value)) {
    if (seen.has(value)) {
      return undefined;
    }
    seen.add(value);
    return value.map((item) => deepRedactWithCycleGuard(item, seen));
  }

  if (typeof value === "object") {
    if (seen.has(value as object)) {
      return undefined;
    }
    seen.add(value as object);
    const redacted: Record<string, unknown> = {};
    for (const key of Object.keys(value as object)) {
      if (PII_KEYS.has(key)) {
        continue;
      }
      redacted[key] = deepRedactWithCycleGuard((value as Record<string, unknown>)[key], seen);
    }
    return redacted;
  }

  return value;
}

function safeJsonByteLength(value: unknown): number | null {
  try {
    const serialized = JSON.stringify(value);
    if (typeof serialized !== "string") {
      return null;
    }
    return serialized.length;
  } catch {
    return null;
  }
}

export function sanitizeEventPayload(payload: unknown): object | undefined {
  if (payload == null || typeof payload !== "object" || Array.isArray(payload)) {
    return undefined;
  }

  const redacted = deepRedact(payload) as object;
  const byteLength = safeJsonByteLength(redacted);
  if (byteLength == null || byteLength > MAX_PAYLOAD_BYTES) {
    return undefined;
  }

  return redacted;
}